.wrap {
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
}

.head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--sp-3);
}

.head .field-label {
  margin-bottom: 0;
}

.customToggle[aria-pressed='true'] {
  background: var(--surface-2);
  border-color: var(--border-strong);
}

.hint {
  margin: 0;
  color: var(--text-3);
  font-size: var(--fs-xs);
}

.combo {
  position: relative;
}

/* Замкнутая обводка списка — var(--bw), как у остальных плавающих панелей. */
.listbox {
  position: absolute;
  z-index: 20;
  top: calc(100% + var(--sp-2));
  left: 0;
  right: 0;
  max-height: 320px;
  overflow-y: auto;
  margin: 0;
  padding: var(--sp-2);
  list-style: none;
  background: var(--surface-raised);
  border: var(--bw) solid var(--border-strong);
  border-radius: var(--radius);
  box-shadow: var(--shadow-lift);
}

.option {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  column-gap: var(--sp-3);
  padding: var(--sp-2) var(--sp-3);
  border-radius: var(--radius);
  cursor: pointer;
  /* Разделитель между строками — волосок, а не замкнутая обводка. */
  border-bottom: 1px solid var(--border);
}

.option:last-child {
  border-bottom: 0;
}

.option:hover,
.optionActive {
  background: var(--surface-2);
}

.optionId {
  font-size: var(--fs-sm);
  color: var(--text);
}

.optionName {
  color: var(--text-2);
  font-size: var(--fs-sm);
}

.optionNone {
  color: var(--text-3);
  font-style: italic;
}

.badges {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--sp-2);
  margin-left: auto;
}

.badge {
  padding: 0 var(--sp-2);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius);
  color: var(--text-3);
  font-size: var(--fs-xs);
  white-space: nowrap;
}

/* «Без строгого JSON» — не подсказка, а предупреждение: с такой моделью
   задача не заработает совсем. Отсюда цвет предупреждения, а не приглушённый
   серый остальных бейджей. */
.badgeWarn {
  padding: 0 var(--sp-2);
  border: var(--bw) solid var(--warn-border);
  border-radius: var(--radius);
  background: var(--warn-bg);
  color: var(--warn);
  font-size: var(--fs-xs);
  white-space: nowrap;
}

.optionMeta {
  color: var(--text-3);
  font-size: var(--fs-xs);
  white-space: nowrap;
}

/* Цена и контекст выбранной модели под полем. */
.selectedMeta {
  display: flex;
  gap: var(--sp-4);
  margin: var(--sp-2) 0 0;
  font-size: var(--fs-xs);
  color: var(--text-2);
}
